import React from 'react'
import { useTheme } from '@mui/material'

const TransferSuccessMessage = ({ inbox, agent }) => {
  const theme = useTheme()

  if (inbox && agent) {
    return (
      <div>
        Conversation has been successfully transferred to{' '}
        <span style={{ fontWeight: theme.bold.bold }}>{inbox?.name}</span>.
        Assignee:{' '}
        <span style={{ fontWeight: theme.bold.bold }}>{agent?.name}</span>{' '}
      </div>
    )
  }

  if (inbox) {
    return (
      <div>
        Conversation has been successfully transferred to{' '}
        <span style={{ fontWeight: theme.bold.bold }}>{inbox?.name}</span>.
      </div>
    )
  }

  return null
}

export default TransferSuccessMessage
